import React from "react";
import { Quote, Leaf } from "lucide-react";
import { ABOUT_BACH } from "@/lib/content";
import { Reveal } from "@/lib/motion";

export default function AboutBachFlower() {
  return (
    <section id="about" className="py-20 sm:py-28 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#F9EAE8]/50 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 -left-24 w-[28rem] h-[28rem] rounded-full bg-[#E7D5A8]/25 blur-3xl pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-10 sm:mb-14">
          <div className="eyebrow mb-3 text-[#2A5C5A]">{ABOUT_BACH.eyebrow}</div>
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-end">
            <blockquote className="lg:col-span-6 relative">
              <Quote className="h-8 w-8 text-[#D5B876] mb-3" strokeWidth={1.2} />
              <p className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0B302F] tracking-tight italic">
                “{ABOUT_BACH.pullquote}”
              </p>
            </blockquote>
            <p className="lg:col-span-6 text-[#0B302F]/75 text-lg leading-relaxed">
              {ABOUT_BACH.intro}
            </p>
          </div>
        </Reveal>

        <Reveal className="mt-14 pt-10 border-t border-[#EAE4DA] flex items-center gap-3 text-[#2A5C5A] text-sm italic font-serif">
          <Leaf className="h-4 w-4 text-[#D5B876]" strokeWidth={1.4} />
          <span>Prepared with sunlight, water and the living energy of the flower itself.</span>
        </Reveal>
      </div>
    </section>
  );
}
